
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specified-commercial-transaction-law",
      function () {
        return require("private-next-pages/specified-commercial-transaction-law/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specified-commercial-transaction-law"])
      });
    }
  